import React from 'react'
import PropTypes from 'prop-types'

import styles from './Table.module.scss'

const renderTableHeader = columns => columns.map((column, i) =>
  <div
    key={`column_${i}`}
    className={styles.tableColumnItem}
  >
    {column}
  </div>
)

const renderTableData = data => data.map((items, i) =>
  <div
    key={`data_${i}`}
    className={styles.tableDataWrapper}
  >
    {
      items.map((item, j) =>
        <div
          key={`data_${i}_${j}`}
          className={styles.tableDataItem}
        >
          {item}
        </div>
      )
    }
  </div>
)

const Table = ({
  columns,
  data
}) => {
  const inlineStyles = {
    'gridTemplateColumns': 'auto '.repeat(columns.length).slice(0, -1)
  }

  return <div
    className={styles.table}
    style={inlineStyles}
  >
    {renderTableHeader(columns)}

    {renderTableData(data)}
  </div>
}

Table.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired
}

export default Table
